import path from 'path';
import { Prompt } from 'react-router-dom';
import React, { Component } from 'react';
import { v4 as uuidV4 } from 'uuid';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'underscore';
import { viewPermissionSelector } from '../../common/classes/permissions';
import entityComposition from '../../common/classes/entityComposition';
import { hasAdminSubSectionPermission } from '../../../utils/paths';
import SectionPanel from '../../common/containers/sectionPanel';
import OrgConditionCosts from './organizationConditionCosts';
import routeHelper from '../../common/classes/routeHelper';
import OrgContainer from './organizationContainer';
import OrgGeneral from './organizationGeneral';
class Organization extends Component {
  constructor(props) {
    if (!props.match.params || !props.match.params.id) {
      throw new Error('props.match.params.id is required');
    }
    super(props);
    this.handleBack = routeHelper.updateURL.bind(routeHelper, '/admin/organizations');
    this.handleChange = (contentPath, value) => {
      props.organizationActions.change(props.organization.active.id, contentPath, value);
    };
    this.handleSave = this.handleSave.bind(this);
    this.validate = this.validate.bind(this);
  }
  componentDidMount() {
    const _this$props = this.props,
      canView = _this$props.canView,
      location = _this$props.location,
      coatingScore = _this$props.coatingScore,
      coatingScoreActions = _this$props.coatingScoreActions,
      match = _this$props.match,
      organization = _this$props.organization,
      organizationActions = _this$props.organizationActions;
    routeHelper.handleViewRedirect(canView, location);
    if (!organization.active.isNew) {
      organizationActions.serverShow(match.params.id);
    }
    if (coatingScore.list && coatingScore.list.length === 0) {
      coatingScoreActions.serverIndex(coatingScore.indexQuery);
    }
  }
  componentDidUpdate() {
    const _this$props2 = this.props,
      coatingScore = _this$props2.coatingScore,
      _this$props2$organiza = _this$props2.organization,
      active = _this$props2$organiza.active,
      loading = _this$props2$organiza.loading,
      setDefaultCoatingScoreDivisions = _this$props2.organizationActions.setDefaultCoatingScoreDivisions,
      userID = _this$props2.userID;
    if (active && active.coatingScoreDivisions && active.coatingScoreDivisions.length === 0 && !loading && coatingScore.list && coatingScore.list.length > 0) {
      const createdDate = moment().utc().format('YYYY-MM-DD HH:mm:ss');
      const coatingScoreDivisionIDs = [];
      for (let i = 0; i < 8; i += 1) {
        coatingScoreDivisionIDs.push(uuidV4());
      }
      setDefaultCoatingScoreDivisions(active.id, userID, coatingScoreDivisionIDs, coatingScore.list, createdDate);
    }
  }
  componentWillUnmount() {
    const showCancel = this.props.organizationActions.showCancel;
    showCancel();
  }
  handleSave() {
    const _this$props3 = this.props,
      organization = _this$props3.organization,
      organizationActions = _this$props3.organizationActions;
    const errors = this.validate();
    const active = organization.active;
    if (errors.length > 0) {
      organizationActions.errorMessage(errors);
    } else {
      organizationActions.serverSave(active);
    }
  }
  validate() {
    const _this$props$organizat = this.props.organization.active,
      coatingScoreDivisions = _this$props$organizat.coatingScoreDivisions,
      name = _this$props$organizat.name;
    const errors = [];
    if (!name) {
      errors.push('The organization name is required.');
    }
    let nullCoatingScores = [];
    nullCoatingScores = _.filter(coatingScoreDivisions, division => division.cost === null);
    if (nullCoatingScores.length > 0) {
      errors.push('All coating score divisions must be filled in.');
    }
    return errors;
  }
  render() {
    const _this$props4 = this.props,
      hasFacilityPermissions = _this$props4.hasFacilityPermissions,
      hasGeneralPermissions = _this$props4.hasGeneralPermissions,
      match = _this$props4.match,
      organization = _this$props4.organization,
      userID = _this$props4.userID;
    let section = match.params.section || 'general';
    const loading = organization.loading,
      pendingChanges = organization.pendingChanges,
      name = organization.active.name;
    if (!hasGeneralPermissions) {
      // we don't want to show the default section.
      section = '';
    }
    const props = {
      organization: organization.active,
      hasFacilityPermissions,
      onChange: this.handleChange,
      userID
    };
    const forms = {
      '': /*#__PURE__*/React.createElement("div", null, "You do not have permissions to administer this information."),
      general: /*#__PURE__*/React.createElement(OrgGeneral, props),
      condCost: /*#__PURE__*/React.createElement(OrgConditionCosts, props)
    };
    const sectionRoutes = Object.keys(forms).map(formKey => path.join('/admin/organizations/', match.params.id, formKey));
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Prompt, {
      when: pendingChanges,
      message: location => routeHelper.transitionAsync(this, 'organization', location, sectionRoutes)
    }), /*#__PURE__*/React.createElement(OrgContainer, {
      section: section,
      id: match.params.id
    }, /*#__PURE__*/React.createElement(SectionPanel, {
      isPending: pendingChanges,
      isSaveDisabled: loading || !pendingChanges,
      onBack: this.handleBack,
      onSave: this.handleSave,
      name: name,
      showSave: true
    }, forms[section])));
  }
}
Organization.propTypes = {
  canView: PropTypes.bool.isRequired,
  location: PropTypes.shape({}).isRequired,
  coatingScore: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  coatingScoreActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  hasFacilityPermissions: PropTypes.bool.isRequired,
  hasGeneralPermissions: PropTypes.bool.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
      section: PropTypes.string
    }).isRequired
  }).isRequired,
  organization: PropTypes.shape({
    loading: PropTypes.bool,
    pendingChanges: PropTypes.bool,
    active: PropTypes.shape({
      coatingScoreDivisions: PropTypes.arrayOf(PropTypes.shape({})),
      id: PropTypes.string,
      isNew: PropTypes.bool,
      name: PropTypes.string
    }).isRequired
  }).isRequired,
  organizationActions: PropTypes.shape({
    change: PropTypes.func,
    errorMessage: PropTypes.func,
    setDefaultCoatingScoreDivisions: PropTypes.func,
    serverSave: PropTypes.func,
    serverShow: PropTypes.func,
    showCancel: PropTypes.func
  }).isRequired,
  userID: PropTypes.string.isRequired
};
export { Organization as TestOrganization };
export default entityComposition(Organization, ['organization', 'coatingScore'], {
  userID: state => state.login.user.user_id,
  hasFacilityPermissions: () => hasAdminSubSectionPermission('organizations_facility'),
  hasGeneralPermissions: () => hasAdminSubSectionPermission('organizations_general'),
  canView: state => viewPermissionSelector('organization')(state)
});